import styled from 'styled-components'

import { AmountFractionStyled } from '@webapp/components/AmountFraction'

interface APItemReceivedCellStyledProps {
  exception?: boolean
}

export const APItemReceivedCellStyled = styled.div<APItemReceivedCellStyledProps>`
  ${AmountFractionStyled} {
    line-height: normal;
    .numerator {
      ${(props) => {
        if (props.exception) {
          return `
          color: ${props.theme.colors.error};
        `
        }
      }}
    }
    & * {
      ${(props) => {
        if (props.exception) {
          return `
          font-weight: ${props.theme.fontWeights.bold};
        `
        }
      }}
    }
  }
`
